import { Component } from "@angular/core";

@Component({
  selector: "app-billing",
  templateUrl: "./billing.component.html",
  styleUrls: ["./billing.component.scss"],
  standalone: false,
})
export class BillingComponent {}
